import { render, staticRenderFns } from "./ActivityServiceProvidersView.vue?vue&type=template&id=694b74e7&lang=pug&"
import script from "./ActivityServiceProvidersView.vue?vue&type=script&lang=ts&"
export * from "./ActivityServiceProvidersView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports